import type { SearchCriteria } from '@awazevr/mfe-common.types-and-mocks.site-search-service'

/** A `/search` path for the params, skipping empty values and comma-joining arrays. */
export const toSearchHref = (params: object): string => {
  const search = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return
    }

    search.set(key, Array.isArray(value) ? value.join(',') : String(value))
  })

  return `/search?${search.toString()}`
}

/** The current search with `useExpandedCoordinates=true`, from page 1. */
export const toExpandedPolygonCriteria = (
  searchCriteria: SearchCriteria,
): SearchCriteria => {
  const criteria: Record<string, unknown> = { ...searchCriteria }
  delete criteria.showExpandedResults
  delete criteria.useExpandedCoordinates
  delete criteria.page

  return {
    ...criteria,
    useExpandedCoordinates: true,
    page: 1,
  } as SearchCriteria
}

/**
 * "View more" re-runs the CURRENT search with `useExpandedCoordinates=true`
 * added and `showExpandedResults` dropped, producing a standard, shareable
 * results page whose results are the expanded-polygon properties. On that page
 * the gate (`!useExpandedCoordinates`) hides the carousel and the view-more CTA.
 */
export const buildViewMoreHref = (searchCriteria: SearchCriteria): string =>
  toSearchHref(toExpandedPolygonCriteria(searchCriteria))
